/** 한샘 AS케어+ DTO 는 파일이 분리돼 있다 — 패키지 루트에서 쓰려면 여기서 다시 내보내야 한다 */
import { ApiPagingResponse, ApiResponse } from '@store/base';
import {
  DeviceChannel,
  EstimateMaterialNotice,
  EstimateNotificationImage,
  OnlineEstimate,
  OnlineEstimateDetail,
  OrderGoodsCurtain,
  OrderGoodsCustom,
  OrderGoodsFabricWindow,
  OrderGoodsNormal,
  OrderNotice,
} from '../vo';

export * from './as-care';

export interface AddCartGoodsRequest {
  dvcChnl: DeviceChannel;
  noLoginUserNo?: number;
  goods: (
    | OrderGoodsNormal
    | OrderGoodsCurtain
    | OrderGoodsFabricWindow
    | OrderGoodsCustom
  )[];
}

export interface AddCartGoodsResponse extends ApiResponse<{}> {}

export interface BuyDirectGoodsRequest {
  dvcChnl: DeviceChannel;
  noLoginUserNo?: number;
  goods: (
    | OrderGoodsNormal
    | OrderGoodsCurtain
    | OrderGoodsFabricWindow
    | OrderGoodsCustom
  )[];
}

export interface BuyDirectGoodsResponse
  extends ApiResponse<{
    directBuyId: string; // 바로구매 아이디
    notice?: OrderNotice | null; // 주문 체크룰 안내 (해당 없으면 null)
  }> {}

/**
 * 회원 온라인견적서 목록 요청
 */
export interface GetOnlineEstimateMemberRequest {
  consultId: number;
  page: number;
  size: number;
}

/**
 * 회원 온라인견적서 목록 응답
 */
export interface GetOnlineEstimateMemberResponse
  extends ApiPagingResponse<OnlineEstimate> {}

/**
 * 회원 온라인견적서 목록 요청
 */
export interface GetOnlineEstimateGuestRequest {
  certificationNo: string;
  custNo: number;
  page: number;
  size: number;
}

/**
 * 회원 온라인견적서 목록 응답
 */
export interface GetOnlineEstimateGuestResponse
  extends ApiPagingResponse<OnlineEstimate> {}

/**
 * 견적서 본인확인 (인증번호생성)
 */
export interface CreateEstimateCertificationRequest {
  estimateId: number;
  name: string;
  mobileNo: string;
}

/**
 * 견적서 본인확인 응답
 */
export interface CreateEstimateCertificationResponse
  extends ApiResponse<{ successYn: boolean }> {}

/**
 * 견적서 본인확인 (인증번호확인)
 */
export interface CreateEstimateCertificationConfirmRequest {
  estimateId: number;
  certificationNo: string;
}

/**
 * 견적서 본인확인 응답 (인증번호확인)
 */
export interface CreateEstimateCertificationConfirmResponse
  extends ApiResponse<{
    successYn: boolean;
    custNo: string;
    consultId: number;
    certificationNo: string;
  }> {}

/**
 * 회원 견적서 내용 조회
 */
export interface GetOnlineEstimateDetailMemberRequest {
  estimateId: number;
}

/**
 * 비회원 견적서 내용 조회
 */
export interface GetOnlineEstimateDetailGuestRequest {
  estimateId: number;
  certificationNo: string;
  custNo: number;
}

/**
 * 견적 주문요청 상태변경
 */
export interface UpdateOnlineEstimateOrderStatusRequest {
  estimateId: number;
}

export interface UpdateOnlineEstimateOrderStatusResponse
  extends ApiResponse<{ successYn: boolean }> {}

/**
 * OFFBEN-83 — 온라인견적서 v3 상세 응답 (version 인지). 요청 타입은 v1과 동일하여 재사용.
 * 목록 응답은 위 GetOnlineEstimate{Member,Guest}Response 재사용(v1·v3 동형).
 */
export interface GetOnlineEstimateDetailMemberResponse
  extends ApiResponse<OnlineEstimateDetail> {}

export interface GetOnlineEstimateDetailGuestResponse
  extends ApiResponse<OnlineEstimateDetail> {}

/**
 * 견적 알림톡 내 참고이미지 조회 (HSMALL-15407 / BE HSMALL-15366)
 * 비로그인 접근 가능. 토큰 만료·미존재 시에도 200 + expired=true 로 응답한다.
 */
export interface GetEstimateNotificationImagesRequest {
  imgref: string; // 암호화된 접근 토큰
}

export interface GetEstimateNotificationImagesResponse
  extends ApiResponse<{
    expired: boolean;
    images?: EstimateNotificationImage[];
  }> {}

/**
 * 소재고지 알림톡 링크 고지내역 조회 (SALES-14036)
 * 비로그인 접근 가능. 유효기간 개념은 없고, 토큰이 유효하지 않거나 재기표로 이력이 삭제된 경우
 * 에러가 아니라 200 + expired=true 로 응답한다.
 */
export interface GetEstimateMaterialNoticesRequest {
  ref: string; // 발송 시 생성된 링크 토큰 (hex 32자)
}

export interface GetEstimateMaterialNoticesResponse
  extends ApiResponse<{
    expired: boolean;
    estimateId?: number | null;
    notices?: EstimateMaterialNotice[];
  }> {}
